// src/lib/validators.js
const isInt = (v) => Number.isInteger(v);
const toNum = (s) => {
  if (s == null) return NaN;
  const t = typeof s === 'string' ? s.trim() : s;
  return t === '' ? NaN : Number(t);
};

export function validateFields(values, { mode = 'simple' } = {}) {
  const {
    normalSpins,
    totalOutput,
    finalDifference,
    chanceSpins,
    decreaseRate,
    ballsPer1000Yen,
    payoutTextSum, // 任意
  } = values;

  const errors = {};
  const warnings = {};

  const n = toNum(normalSpins);
  if (!Number.isFinite(n) || !isInt(n) || n < 0) {
    errors.normalSpins = '通常時回転数は0以上の整数で入力してください。';
  }

  const to = toNum(totalOutput);
  if (!Number.isFinite(to) || !isInt(to) || to < 0) {
    errors.totalOutput = '獲得出玉は0以上の整数で入力してください。';
  }

  const fd = toNum(finalDifference);
  if (!Number.isFinite(fd)) {
    errors.finalDifference = '最終差玉は数値で入力してください（マイナス可）。';
  }

  const cs = toNum(chanceSpins);
  if (!Number.isFinite(cs) || !isInt(cs) || cs < 0) {
    errors.chanceSpins = 'チャンス中回転数は0以上の整数で入力してください。';
  }

  const dr = toNum(decreaseRate);
  if (!Number.isFinite(dr) || dr < 0 || dr > 0.9) {
    errors.decreaseRate = '持ち玉減少率は0〜0.9の範囲で入力してください（例: 0.1）。';
  }

  const b1000 = toNum(ballsPer1000Yen);
  if (!Number.isFinite(b1000) || b1000 <= 0) {
    errors.ballsPer1000Yen = '貸し玉数は正の数で入力してください。';
  } else if (mode !== 'simple' && (b1000 < 150 || b1000 > 300)) {
    warnings.ballsPer1000Yen = '貸し玉数が一般的な範囲(150〜300)から外れています。';
  }

  // クロス
  if (Object.keys(errors).length === 0) {
    // simple と detail で式を揃える
    const actualInvestment =
      mode === 'simple' ? ((to - fd) * (1 - dr)) / b1000 : (to - fd - cs * dr) / b1000;
    if (!Number.isFinite(actualInvestment) || actualInvestment <= 0) {
      // フォーム全体のメッセージも付与（上部にまとめて出せるように）
      errors._form =
        '実投資が0以下になっています。獲得出玉と最終差玉（必要なら減少率）を見直してください。';
    }
  }

  // 乖離（詳細モードのみ）
  if (mode !== 'simple' && Number.isFinite(to) && Number.isFinite(payoutTextSum)) {
    if (payoutTextSum > 0) {
      const diffRate = Math.abs(payoutTextSum - to) / payoutTextSum;
      if (diffRate > 0.03) {
        warnings.totalOutput = `モーダル合計(${payoutTextSum})と入力値(${to})に差があります（±3%超）。`;
      }
    }
  }

  return { isValid: Object.keys(errors).length === 0, errors, warnings };
}
